import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcGrowthCalculatorWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderGrowthCalculator();
}
